module.exports = {
  OFFICIAL_NAME: 'OFFICIAL_NAME',
  FANTASY_NAME: 'FANTASY_NAME'
};
